export default "__VITE_ASSET__bd54e347__"